export default __webpack_public_path__ + "static/media/section3_4_1.42b6e8f7.png";